module.exports = __webpack_public_path__ + "static/media/metabolism.bdf0e947.svg";